module.exports = __webpack_public_path__ + "static/media/icon-popup-document.52061383.svg";